import {
  Component,
  forwardRef,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { environment } from "@env/environment";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import { UtilService } from "@app/modules/shared/services/util.service";
import { KlPreferenceSaveFormComponent } from "@app/modules/shared/components/preference-form/kl-preference-save-form.component";

declare var Stimulsoft: any;
declare var StiOptions: any;

@Component({
  selector: "kl-report-designer",
  templateUrl: "./kl-report-designer.component.html",
  styleUrls: ["./kl-report-designer.component.scss"],
})
export class KlReportDesignerComponent implements OnInit {
  options: any;
  designer: any;
  report: any;
  dataRelation: any;
  mode: string;
  parentModule: string;
  module: string;
  designObject: any;
  key: string;
  type: string;
  currentReport: any;
  event: any;
  showSaveModal = true;

  @ViewChild(forwardRef(() => KlPreferenceSaveFormComponent), {
    static: true,
  })
  klPreferenceSaveFormComponent: any;

  static get apiUrl() {
    return localStorage.getItem("apiUrl")
      ? localStorage.getItem("apiUrl")
      : environment.apiUrl;
  }

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private utilService: UtilService,
    private translateService: TranslateService
  ) {
    const localLanguage = localStorage.getItem("currentLanguage");
    translateService.use(localLanguage);
  }

  ngOnInit() {
    const newWindow: any = window;
    this.options = new Stimulsoft.Designer.StiDesignerOptions();
    this.designer = new Stimulsoft.Designer.StiDesigner(
      this.options,
      "StiDesigner",
      false
    );
    this.report = new Stimulsoft.Report.StiReport();
    if (newWindow.mode === "add") {
      this.mode = newWindow.mode;
      this.parentModule = newWindow.parentModule;
      this.module = newWindow.module;
      this.currentReport = newWindow.currentReport;
      this.type = newWindow.type;
      this.key = newWindow.key;
      this.designObject = newWindow.designObject;
      StiOptions.WebServer.url = "http://localhost:3000";
      this.options.appearance.fullScreenMode = true;
      const dataSet = new Stimulsoft.System.Data.DataSet("JSON");
      dataSet.readJson(newWindow.sourceData);
      this.report.regData("JSON", "JSON", dataSet);
      this.report.dictionary.synchronize();
      this.translate();
      this.relationData();
      this.designer.report = this.report;
      this.designer.renderHtml("designer");
    } else if (newWindow.mode === "edit") {
      this.mode = newWindow.mode;
      this.parentModule = newWindow.parentModule;
      this.module = newWindow.module;
      this.type = newWindow.type;
      this.currentReport = JSON.parse(newWindow.currentReport);
      this.key = newWindow.key;
      this.designObject = newWindow.designObject;
      this.options = new Stimulsoft.Designer.StiDesignerOptions();
      this.options.appearance.fullScreenMode = true;
      const dataSet = new Stimulsoft.System.Data.DataSet("JSON");
      dataSet.readJson(newWindow.sourceData);
      this.report.regData("JSON", "JSON", dataSet);
      this.report.dictionary.synchronize();
      this.designer = new Stimulsoft.Designer.StiDesigner(
        this.options,
        "StiDesigner",
        false
      );
      this.report.load(this.currentReport.content);
      this.translate();
      this.designer.report = this.report;
      this.designer.renderHtml("designer");
    } else {
      newWindow.close();
    }
    this.showSaveModal = newWindow.showSaveModal;
    this.designer.onSaveReport = (event) => {
      this.event = event;
      if (this.showSaveModal) {
        this.openEntryNameModal();
      } else {
        this.commitSave({});
      }
    };
    this.designer.onSaveAsReport = (event) => {
      this.event = event;
      this.mode = "add";
      if (this.showSaveModal) {
        this.openEntryNameModal();
      } else {
        this.commitSave({});
      }
    };
    this.designer.onCreateReport = () => {
      this.mode = "add";
    };
  }

  translate() {
    for (let k = 0; k < this.report.dictionary.dataSources.items.length; k++) {
      this.report.dictionary.dataSources.items[k].alias =
        this.translateService.instant(
          this.report.dictionary.dataSources.items[k].name
        );
      for (
        let i = 0;
        i < this.report.dictionary.dataSources.items[k].columns.list.length;
        i++
      ) {
        this.report.dictionary.dataSources.items[k].columns.list[i].alias =
          this.translateService.instant(
            this.report.dictionary.dataSources.items[k].columns.list[i].name
          );
      }
    }
  }

  relationData() {
    if (this.module === "VIRTUAL_ORDER_DESIGN_LIST") {
      this.dataRelation = new Stimulsoft.Report.Dictionary.StiDataRelation(
        "customer",
        "customer",
        "customer",
        this.report.dictionary.dataSources.getByName("customer"),
        this.report.dictionary.dataSources.getByName("report_fields"),
        ["id"],
        ["customer_id"]
      );
      this.report.dictionary.relations.add(this.dataRelation);
      this.dataRelation = new Stimulsoft.Report.Dictionary.StiDataRelation(
        "current_account",
        "current_account",
        "current_account",
        this.report.dictionary.dataSources.getByName("current_account"),
        this.report.dictionary.dataSources.getByName("report_fields"),
        ["id"],
        ["current_account_id"]
      );
      this.report.dictionary.relations.add(this.dataRelation);
    }
  }

  handleError(error) {
    alert(this.utilService.alertErrorMessage(error));
  }

  commitSave(event: any) {
    const commitObject = {
      parent: {
        module: this.parentModule,
      },
      level: event.levelStatus ? "USER" : "APPLICATION",
      level_default: event.levelDesign ? "DEFAULT" : "NO_DEFAULT",
      description: this.event.fileName,
      module: this.module,
      type: this.type,
      key: this.key,
      content: this.event.report.saveToJsonString(),
    };
    Object.assign(commitObject, this.designObject);
    switch (this.mode) {
      case "add":
        this.http
          .post<any>(
            KlReportDesignerComponent.apiUrl + "/design",
            commitObject,
            {
              headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
              },
            }
          )
          .subscribe(
            (resPreference) => {
              this.currentReport = resPreference.data;
              this.mode = "edit";
              this.closeEntryModal();
            },
            (errPreference) => this.handleError(errPreference)
          );
        break;
      case "edit":
        commitObject["id"] = this.currentReport.id;
        this.http
          .put(KlReportDesignerComponent.apiUrl + "/design", commitObject, {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
          })
          .subscribe(
            () => {
              this.closeEntryModal();
            },
            (errPreference) => this.handleError(errPreference)
          );
        break;
    }
  }

  openEntryNameModal(currentFilter?: any) {
    this.klPreferenceSaveFormComponent.show(this.mode, "filter", currentFilter);
  }

  closeEntryModal() {
    this.klPreferenceSaveFormComponent.hide();
  }
}
